import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import React, { useState } from "react";
import { sizes } from "../../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import { getScDSAData, getScenarioDetails, setState, reset } from "./editScenarioNewSlice";
import { useEffect } from "react";
import dayjs from "dayjs";
import './ScenarioEdit.css'

export default function SelectScenario() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const {
		editScenarioList,
		editScName,
		editScID,
		editScDetails,
		customerLevels,
		customerTypes, 
		predictionMethodPeriodList, 
		previousYearPeriodList,
		DefaultInitialForecast 
	} = setupState;
	const [selectedScenario, setSelectedScenario] = useState([]);

	function setCustomerInfoFromSelectedScenario() {
		dispatch(
			setState(
				"selectedCL",
				editScDetails.customers[0].customer.customerLevel
			)
		);
		dispatch(setState("selectedCLID", editScDetails.scenarioLevel));

		const typeCode = editScDetails.customers[0].customer.customerTypeCode;
		const type = customerTypes.find(
			(custType) => custType.customerTypeCode === typeCode
		).customerTypeName;

		dispatch(setState("selectedCustType", type));
		dispatch(setState("selectedCTCode", typeCode));
	}

	function setCGInfoFromSelectedScenario() {
		dispatch(setState("selectedCLID", editScDetails.scenarioLevel));
		const level = customerLevels.find(
			(level) => level.customerLevelID === editScDetails.scenarioLevel
		).customerLevel;
		dispatch(setState("selectedCL", level));

		dispatch(
			setState(
				"selectedCTCode",
				editScDetails.customerGroups[0].customerGroup.customerGroupTypeCode
			)
		);
		const type = customerTypes.find(
			(t) =>
				t.customerTypeCode ===
				editScDetails.customerGroups[0].customerGroup.customerGroupTypeCode
		).customerTypeName;
		dispatch(setState("selectedCustType", type));
	}

	function setScenarioInfoFromSelectedScenario() {
		dispatch(setState("scenarioName", editScDetails.scenarioName));
		dispatch(
			setState("createFromDate", dayjs(editScDetails.effectiveStartDate))
		);
		dispatch(setState("createToDate", dayjs(editScDetails.effectiveEndDate)));
		if (editScDetails.sentToSAP === "Y" || editScDetails.sentToSAP === "N") {
			dispatch(setState("sentToSAP", true));
		} else {
			dispatch(setState("sentToSAP", false));
		}
		if(editScDetails.sentToSAP === "Y" && editScDetails.scenarioName?.indexOf('.old') < 0 && editScDetails.scenarioStatus == 'Approved'){
			dispatch(setState("isCloneDisable", true));
		}
		else{
			dispatch(setState("isCloneDisable", false));
		}
		if(editScDetails.scenarioName?.indexOf('.old') < 0 && editScDetails.scenarioStatus == 'Approved'){
			dispatch(setState("isCopyDisable", true));
		}
		else{
			dispatch(setState("isCopyDisable", false));
		}
		if(editScDetails.sentToSAP === "Y" && editScDetails.scenarioStatus == 'Approved'  || editScDetails.scenarioName?.indexOf('.old') > 0){
			dispatch(setState("isButtonDisable", true));
		}
		else{
			dispatch(setState("isButtonDisable", false));
		}
		dispatch(setState("scenarioStatus", editScDetails.scenarioStatus));
		dispatch(setState("countryID", editScDetails.countryID));
	}

	function setDefaultSafetyMarginsFromSelectedScenario() {
		dispatch(
			setState(
				"DSMHigh",
				editScDetails.scenarioSafetyMargins[0].safetyMargin
			)
		);
		dispatch(
			setState("DSMMed", editScDetails.scenarioSafetyMargins[1].safetyMargin)
		);
		dispatch(
			setState("DSMLow", editScDetails.scenarioSafetyMargins[2].safetyMargin)
		);
		dispatch(
			setState("DSMOth", editScDetails.scenarioSafetyMargins[3].safetyMargin)
		);
	}

	function setSelectedCustomerCGsFromSelectedScenario() {
		let tempList = [];
		if (editScDetails.customers.length > 0) {
			editScDetails.customers.forEach((cust) => {
				tempList.push(cust.customer);
			});
		}
		if (editScDetails.customerGroups.length > 0) {
			editScDetails.customerGroups.forEach((cg) => {
				tempList.push(cg.customerGroup);
			});
		}
		if(editScDetails.customerType.length > 0){
			editScDetails.customerType.forEach((custType) => {
				var cObj = custType['customerType'];
				let tempdata = {
				  name: cObj['customerTypeName'], id: cObj['customerTypeCode'],
				  type: 'CT', uniqueID: '0', countryID: 0, code: '', parentName: '', sapCustomerNumber: 0
				}
				tempList.push(tempdata);
			});
		}
		console.log(tempList);
		dispatch(setState("selectedCustsCGs", tempList));
	}

    // api to get data source alignment data for scenario
    // http://172.19.79.4/sims_demo_wave3_api/api/Scenario/GetDataSourceAlignmentDataForScenario?scenarioId=31392

	function setSelectedDataSourcesFromSelectedScenario() {
		let list = [];
		editScDetails.scenarioDatasource.forEach((item) => {
			list.push(item.dataSourceName);
		});
		const primaryDataSource = editScDetails.scenarioDatasource.find(
			(s) => s.dataSourceID === editScDetails.primaryDataSourceID
		).dataSourceName;
		dispatch(setState("selectedDSs", list));
		dispatch(setState("selectedPDS", primaryDataSource));
	}

	function setDefineScenarioSettingsFromSelectedScenario() {
		dispatch(setState("minimumQuota", editScDetails.minimumQuota));
		dispatch(setState("skuBreakdown", editScDetails.skuBreakdown));
		dispatch(setState("criticalityId", editScDetails.criticalityId));
		if (editScDetails.displayStickToQuota === 1) {
			dispatch(setState("selectedScSTQ", "Enabled"));
		} else {
			dispatch(setState("selectedScSTQ", "Disabled"));
		}
	}

	function setCustomerBdMethodFromSelectedScenario() {
		dispatch(
			setState("customerBreakdownType", editScDetails.customerBreakdownType)
		);
		dispatch(setState("customerBreakdown", editScDetails.customerBreakdown));
		dispatch(setState("emailNotification", editScDetails.emailNotification));
		dispatch(setState("email", editScDetails.email));
	}

	function setSelectedSkuPGsFromSelectedScenario() {
		let tempPGs = [];
		editScDetails.productGroup.forEach((item) => {
			console.log(item);
			tempPGs.push(item.productGroup);
		});

		editScDetails.product.forEach((item) => {
			console.log(item);
			tempPGs.push(item.product);
		});
		dispatch(setState("selectedPGs", tempPGs));
	}
	function setPredictionMethodFromSelectedScenario() {
		dispatch(
			setState("selectedLinearTrend", editScDetails.linearFCTimePeriod)
		);
		dispatch(setState("selectedRunRate", editScDetails.runRateTimePeriod));
		dispatch(setState("selectedConsensusFCC1", editScDetails.financialFCTimePeriod));
		dispatch(setState("selectedConsensusFCC2", editScDetails.productionFCTimePeriod));
		dispatch(setState("selectedPreviousYear", editScDetails.previousYearTimePeriod));
	}
	function setAuthorizedDeviationFromSelectedScenario() {
		dispatch(
			setState("quotaDeviationPercentage", editScDetails.quotaDeviationPercentage)
		);
		dispatch(setState("modificationDeviationPercentage", editScDetails.modificationDeviationPercentage));
	}
	function setMarketShareComparison(){
		dispatch(setState("marketShareComparisonList", editScDetails.marketShareComparisonList));
		dispatch(setState("previousMarketShareComparisonList", editScDetails.marketShareComparisonList));
		dispatch(setState("refList",editScDetails.referenceSKUList));
		dispatch(setState("MarketShareTimePeriod", editScDetails.marketShareComparisonPeriod));
		dispatch(setState("PreviousMarketShareTimePeriod", editScDetails.marketShareComparisonPeriod));
		if(editScDetails.marketShareComparisonList.length > 0){
			let manually_define_MS_Sum = 0;
			let manually_define_MS_List = [];
			let mdList = {};
			manually_define_MS_Sum = editScDetails.marketShareComparisonList
			.reduce((a, b) => a + Number(b.manually_Defined_MS), 0)
			.toFixed(0);
			for (let i = 0; i < editScDetails.marketShareComparisonList.length; i++) {
			  mdList = {};
			  mdList.id = editScDetails.marketShareComparisonList[i].id;
			  mdList.share = Number(editScDetails.marketShareComparisonList[i].manually_Defined_MS);
			  mdList.name = editScDetails.marketShareComparisonList[i].name;
			  mdList.type = editScDetails.marketShareComparisonList[i].type;
			  manually_define_MS_List.push(mdList);
			}
			if(Number(manually_define_MS_Sum) === 100){
				dispatch(setState("manually_defineMSList", manually_define_MS_List));
			}
		}
	}

	useEffect(() => {
		if (editScDetails !== null) {
			setScenarioInfoFromSelectedScenario();
			//setDefaultSafetyMarginsFromSelectedScenario();
			setSelectedCustomerCGsFromSelectedScenario();
			setSelectedDataSourcesFromSelectedScenario();
			setDefineScenarioSettingsFromSelectedScenario();
			setCustomerBdMethodFromSelectedScenario();
			setSelectedSkuPGsFromSelectedScenario();
			setPredictionMethodFromSelectedScenario();
			setAuthorizedDeviationFromSelectedScenario();
			setMarketShareComparison();

			dispatch(
				setState("primaryDataSourceID", editScDetails.primaryDataSourceID)
			);
			dispatch(setState("periodType", editScDetails.periodType));
			dispatch(
				setState("SafetyMargin", editScDetails.scenarioSafetyMarginType)
			);
			dispatch(setState("email",editScDetails.notificationEmailAddress));
			dispatch(setState("comments",editScDetails.comments))
			console.log(editScDetails.scenarioSafetyMarginType.map(x=>x.Type));
			let safetyMarginList = editScDetails.scenarioSafetyMarginType.filter(x=>x.type !=="Customer Group");
			dispatch(setState("selectedcustomerTypes", safetyMarginList.map(x=>x.type)));
			if (editScDetails.customers.length > 0) {
				setCustomerInfoFromSelectedScenario();
			} else if (editScDetails.customerGroups.length > 0) {
				setCGInfoFromSelectedScenario();
			}
			dispatch(setState("selectedDefaultInitialForecast", editScDetails.defaultInitialForecast));
			dispatch(setState("selectedTL", "All"));
			dispatch(setState("selectedTLID", 0));
			dispatch(setState("selectedCustCat", "All"));
			dispatch(setState("scenarioExternalDataSource",editScDetails.scenarioExternalDataSource));
			dispatch(setState("scenarioExternalDataSourceSKU",editScDetails.skuExternalBreakdown));
		}
	}, [editScDetails]);

	function handleChange(event) {
		dispatch(reset("selectScenario"));
		const id = Number(event.target.value);
		const name = editScenarioList.find(
			(scenario) => scenario.scenarioID=== id
		).scenarioName;
		dispatch(setState("editScName", name));
		dispatch(setState("editScID", id));
		let ids = []
		ids.push(event.target.value);
		setSelectedScenario(ids);
		if (id ==="") {
			return;
		}
		const obj = {
			scenarioId: id,
		};
		dispatch(getScenarioDetails(obj)).then(() =>{
			dispatch(getScDSAData(obj));
		});

	}

	useEffect(()=>{
		if(editScID === "" || editScID === null || editScID === undefined){
			setSelectedScenario([]);
		}else{
			let ids = []
			ids.push(editScID);
			setSelectedScenario(ids);
		}
	}, [editScID])

	// useEffect(()=>{
	// 	dispatch(reset("selectScenario"));
	// 	if (editScID ==="") {
	// 		return;
	// 	}
	// 	const obj = {
	// 		scenarioId: editScID,
	// 	};
	// 	dispatch(getScenarioDetails(obj)).then(() =>{
	// 		dispatch(getScDSAData(obj));
	// 	});
	// },[editScID]);

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	return (
		<Box 
			sx={{
				mt: 1
			}}
		>
			<Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2} pb={1} 
			// maxWidth={"99%"}
			>
				<Grid item xs={12} sm={12} md={12} lg={12}>
					<Box sx={{ml:1, borderLeft: 1, borderColor: "#c6c6c6"}}>
						<FormControl className={"fulldoubleHeight"} fullWidth sx={{
									//height: sizes.h45,
									mt: 1,
									ml: 3,
									width: '100%',
								}}>
							<InputLabel shrink htmlFor="select-multiple-native">
								Select Scenario
							</InputLabel>
							<Select
								multiple
								native
								labelId="demo-simple-select-label"
								//id="demo-simple-select"
								value={selectedScenario}
								label="Select Scenario"
								onChange={handleChange}
								className="fulldoubleHeight"
								style={{ width: "97%",  height: "100%"
								}}
							>
								{editScenarioList.map((scenario) => {
									return (
										<option value={scenario.scenarioID}>
											{scenario.scenarioName} : {scenario.scenarioStatus}
										</option>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>

				{/* <Grid item xs={1} sm={1} md={2} lg={1.2}>
					<Box>
						<Button
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								padding:2,
								width: "20px !important",

								"&:hover": {
									bgcolor: "lightBlue.main",
								},
							}}
							onClick={handleScenarioDetails}
						>
							Go
						</Button>
					</Box>
				</Grid> */}
			</Grid>
			{/* <Box sx={{ mt: 0 }}>
				<Typography variant="subtitle2" fontWeight={700}>
					Scenarios Found: {editScenarioList.length}
				</Typography>
			</Box> */}
		</Box>
	);
}
